import { PathOptions } from "leaflet";

const normalize = (s: string) =>
  s
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036F]/g, "");

export const transnordestina_trecho_ferroviario_valec_pe = (
  feature: any
): PathOptions => {
  const situacao = normalize(feature?.properties?.situacao ?? "");

  // "Obras Executadas" — trecho concluído, linha contínua
  if (situacao === "obras executadas") {
    return {
      color: "#B8860B",
      weight: 3,
      opacity: 1,
    };
  }

  // "Em Obras" (e demais situações) — linha tracejada
  return {
    color: "#B8860B",
    weight: 3,
    opacity: 1,
    dashArray: "10 6",
  };
};
